import type { ApolloCache } from "@apollo/client";

import {
  type GetIssuesWithActionsQuery,
  gql,
} from "@medbillai/generated-graphql-types";

export const checkLinksQuery = gql(/* GraphQL */ `
  query CheckInsuranceLinks {
    me {
      id
      flexpaLinks {
        id
        active
      }
      webAgentLinks {
        __typename
        id
        active
      }
    }
  }
`);

export const getWelcomePromptsQuery = gql(/* GraphQL */ `
  query GetWelcomePrompts($benefitsSummaryCaseType: String!) {
    getWelcomePrompts {
      type
      completed
    }
    mostRecentBenefitsSummaryCase: me {
      issues(
        filter: {
          caseType: { eq: $benefitsSummaryCaseType }
          events: {
            eventType: {
              eq: BENEFITS_SUMMARY_GENERATED
            }
          }
        }
        order: { openedAt: { dir: DESC } }
        first: 1
      ) {
        id
      }
    }
  }
`);

export const getPersonalizedPromptsQuery = gql(/* GraphQL */ `
  query GetPersonalizedPrompts {
    getPersonalizedPrompts {
      prompts {
        id
        text
        response
        caseType
        icon
      }
    }
  }
`);

export const getIssuesWithActionsQuery = gql(/* GraphQL */ `
  query GetIssuesWithActions {
    me {
      id
      issues(filter: { hasActions: { eq: true }, closedAt: { exists: false } }) {
        id
        title
        openedAt
        caseType
        actions {
          id
          eventType
          actionRequired
        }
      }
    }
  }
`);

export const getMostRecentClosedIssueWithoutFeedbackQuery = gql(/* GraphQL */ `
  query MostRecentIssueWithClosedEventWithoutFeedback($userId: ID!) {
    issue__ClosedEvent(
      filter: { 
        feedback: { exists: false },
        issue: { owner: { id: { eq: $userId } }, closedAt: { exists: true } }
      }
      order: { sentAt: { dir: DESC } }
      first: 1
    ) {
      id
      sentAt
      issue {
        id
        title
        openedAt
        caseType
        dollarAmountSaved
        totalBillDollarAmount
      }
    }
  }
`);

export const showWelcomeScreenQuery = gql(/* GraphQL */ `
  query ShowWelcomeScreen {
    showWelcomeScreen
  }
`);

export const removeActionFromCache = (
  cache: ApolloCache<unknown>,
  actionId: string,
) => {
  // Remove the corresponding action from the cached GetIssuesWithActions query
  try {
    cache.updateQuery<GetIssuesWithActionsQuery>(
      { query: getIssuesWithActionsQuery },
      prev => {
        if (!prev?.me?.issues) {
          return prev;
        }
        return {
          ...prev,
          me: {
            ...prev.me,
            issues: prev.me.issues.map(issue => ({
              ...issue,
              actions: (issue.actions || []).filter(
                action => action.id !== actionId,
              ),
            })),
          },
        };
      },
    );
  } catch {
    // No-op if the query is not in cache
  }
};
